import { Box, Typography, Link } from "@mui/material";

const cities = ["Delhi", "Mumbai", "Noida", "Gurgaon", "Bangalore", "Chennai", "Pune", "Hyderabad", "Kolkata", "Ahmedabad"];
const bhks = ["2BHK", "3BHK", "4BHK", "5BHK"];
const purposes = ["Buy", "Rent/Lease"];

const generateLinks = () => {
  const links = [];
  for (let city of cities) {
    for (let bhk of bhks) {
      for (let purpose of purposes) {
        links.push({
          label: `${bhk} in ${city} for ${purpose}`,
          href: `/search-results?city=${city}&purpose=${encodeURIComponent(purpose)}&bhk=${bhk}`,
        });
        if (links.length === 50) return links;
      }
    }
  }
  return links.slice(0, 50);
};

const links = generateLinks();

const SecondaryFooter = () => {
  const chunkSize = 10;
  const chunks = Array.from({ length: Math.ceil(links.length / chunkSize) }, (_, i) =>
    links.slice(i * chunkSize, i * chunkSize + chunkSize)
  );

  return (
    <Box bgcolor="#f0f0f0" px={4} py={6} width="100%">
      <Typography variant="h6" mb={3}>
        Explore Properties
      </Typography>
      <Box display="flex" flexWrap="wrap" justifyContent="space-between">
        {chunks.map((chunk, i) => (
          <Box key={i} minWidth={200} mb={3}>
            {chunk.map((link, idx) => (
              <Link
                key={idx}
                href={link.href}
                underline="hover"
                color="textPrimary"
                sx={{ display: "block", mb: 1, fontSize: "14px" }}
              >
                {link.label}
              </Link>
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default SecondaryFooter;
